import { useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header({ openAbout }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const closeMenu = () => setIsOpen(false);

    return (
        <header className="header">
            <div className="container nav">

                <a href="/" className="brand" aria-label="Home">
                    <img src="/img/Ninoa_small_logo.svg" alt="Ninoa" className="logo" />
                </a>

                <button
                    className={`burger ${isOpen ? "open" : ""}`}
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* DESKTOP NAV — 4 anchors + CTA + language */}
                <nav className="navlinks-desktop">
                    <a className="nav-link" href="/#features">{t("nav.features")}</a>
                    <a className="nav-link" href="/#pricing">{t("nav.pricing")}</a>
                    <a className="nav-link" href="/#conditions">{t("nav.conditions")}</a>
                    <a className="nav-link" href="/blog">{t("header.blog")}</a>

                    <div className="nav-actions">
                        <LanguageSwitcher />
                        <a className="btn btn--primary btn--arrow nav-cta" href="/#download">{t("nav.try_free")}</a>
                    </div>
                </nav>
            </div>

            {/* MOBILE OVERLAY */}
            <div className={`drawer-overlay ${isOpen ? "show" : ""}`} onClick={closeMenu}></div>

            {/* MOBILE DRAWER — full nav including About / Privacy */}
            <nav className={`drawer-menu ${isOpen ? "open" : ""}`}>
                <button className="drawer-close" onClick={closeMenu}>
                    <span></span>
                    <span></span>
                </button>

                <a className="drawer-link" href="/#features" onClick={closeMenu}>{t("nav.features")}</a>
                <a className="drawer-link" href="/#pricing" onClick={closeMenu}>{t("nav.pricing")}</a>
                <a className="drawer-link" href="/#conditions" onClick={closeMenu}>{t("nav.conditions")}</a>
                <a className="drawer-link" href="/blog" onClick={closeMenu}>{t("header.blog")}</a>
                <a className="drawer-link" href="/#download" onClick={closeMenu}>{t("nav.download")}</a>

                <div className="drawer-divider" />

                <button
                    className="drawer-link"
                    onClick={() => { closeMenu(); openAbout(); }}
                >
                    {t("header.about")}
                </button>

                <a className="drawer-link" href="/privacy" onClick={closeMenu}>
                    {t("header.privacy")}
                </a>

                <LanguageSwitcher />
            </nav>
        </header>
    );
}
